import { render, staticRenderFns } from "./homebottom1.vue?vue&type=template&id=542601dc&scoped=true"
import script from "./homebottom1.vue?vue&type=script&lang=js"
export * from "./homebottom1.vue?vue&type=script&lang=js"
import style0 from "./homebottom1.vue?vue&type=style&index=0&id=542601dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542601dc",
  null
  
)

export default component.exports